import { ww } from 'bobjoll/ts/library/dom';

ww.advertisement = true;
